<script setup>
  import dayjs from "dayjs";
  import { computed } from "vue";

  const props = defineProps({
    movieList: { type: Array, default: () => [] },
    movieId: { type: Number, default: 0 },
    duration: { type: Array, default: () => [] },
    // 公開前モード（DEV-14891）：不选期间，副标题显示公开日而非集計期間
    preRelease: { type: Boolean, default: false },
  });

  // 选中作品的公开日（YYYY/MM/DD），取不到时显示「—」
  const openDateText = computed(() => {
    const openDate = props.movieList.find((item) => item.id === props.movieId)?.openDate;
    return openDate ? dayjs(openDate).format('YYYY/MM/DD') : '—';
  });
</script>

<template>
  <header class="header">
    <div class="header-title">
        <div class="badge">BOX OFFICE ANALYTICS</div>
        <h1>{{ movieList.find((item) => item.id === movieId)?.name }}</h1>
        <div v-if="preRelease" class="subtitle">公開日: {{ openDateText }}</div>
        <div v-else class="subtitle">集計期間: {{ dayjs(duration[0]).format('YYYY/MM/DD') }} ~ {{ dayjs(duration[1]).format('YYYY/MM/DD') }}</div>
    </div>
    <div class="header-meta">
        <div style="color:var(--text-secondary)"><i class="far fa-clock"></i> 最終更新: {{ dayjs().format('YYYY年MM月DD日') }}</div>
    </div>
  </header>
</template>
<style lang="less" scoped>
 .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
  background: var(--bg-panel);
  padding: 20px 24px;
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  .header-title {
    .badge {
      padding: 4px 12px;
      background: var(--brand-color);
      border-radius: 4px;
      /* 浅色红底用白字保证对比；深色黄底沿用深色字（见下方 html.dark 覆盖） */
      color: #fff;
      font-size: 0.75rem;
      font-weight: 600;
      margin-bottom: 8px;
      display: inline-block;
    }
    h1 {
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--text-primary);
      letter-spacing: -0.3px;
    }
    .subtitle {
      font-size: 0.85rem;
      color: var(--text-secondary);
      margin-top: 4px;
      font-weight: 500;
    }
  }
}
</style>